import { useEffect } from 'react';

import { useUser, supabaseClient } from '@auth-v2';
import { useQueryClient } from '@tanstack/react-query';

import { subscribeToUserSettings } from '@data';
import { queryKeys } from '@queries';

export const useSubscribeToUserSettings = () => {
    const { data: user } = useUser();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!user?.id) return;
        const subscription = subscribeToUserSettings(supabaseClient, user.id, () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.layout.all(user.id) });
            queryClient.invalidateQueries({ queryKey: queryKeys.user.settings(user.id) });
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [queryClient, user?.id]);
};
